// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__gPGl0","submit-button":"styles_submit-button__6PPFJ"};